import destination from '@turf/destination';
import transformScale from '@turf/transform-scale';
import bboxPolygon from '@turf/bbox-polygon';

const google = window.google;

// Converts Google LatLngBounds into geoJson Polygon shape
export const boundsToArray = latLngBounds => {
  const NE = latLngBounds.getNorthEast();
  const SW = latLngBounds.getSouthWest();
  return [[SW.lng(), SW.lat()], [NE.lng(), NE.lat()]];
};

// Takes a bounds array and scales its size
// while maintaing aspect ratio. The bbox and transform
// are kinda gross, they take a flat array "ploygon" and
// return reults in nested arrays.
export const scaleBounds = (array, scale = 1.01) => {
  const bbox = bboxPolygon([...array[0], ...array[1]]);
  var scaledPoly = transformScale(bbox, scale);
  const { coordinates } = scaledPoly.geometry;
  const coords = [coordinates[0][0], coordinates[0][2]];
  return coords;
};

// Converts geoJson polygon shape to Google LatLngBounds
export const arrayToBounds = polygon => {
  return new google.maps.LatLngBounds(
    arrayToPoint(polygon[0]),
    arrayToPoint(polygon[1])
  );
};

export const arrayToPoint = array => {
  return new google.maps.LatLng(array[1], array[0]);
};

// Converts center geoJson Point shape to a
// geoJson polygon shape for `radius` km at aspect ratio
export const pointToBounds = (center, radius, aspectRatio = 1) => {
  const width = radius * aspectRatio;
  const height = radius;
  // Find the length of the hypotnuse
  const newRadius = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
  // find the angle from center to corners at aspect ratio
  const sinOfRadius = width / newRadius;
  const neBearing = (Math.asin(sinOfRadius) * 180) / Math.PI;
  const swBearing = (180 - neBearing) * -1;
  // get the new NE and SW coords
  const NE = destination(center, newRadius, neBearing);
  const SW = destination(center, newRadius, swBearing);
  return [SW.geometry.coordinates, NE.geometry.coordinates];
};

// Convert polygon to point
export const boundsToPoint = polygon => {
  const latLngBounds = arrayToBounds(polygon);
  const center = latLngBounds.getCenter();
  return [center.lng(), center.lat()];
};

const GoogleMaps = {
  boundsToArray,
  arrayToBounds,
  arrayToPoint,
  pointToBounds,
  boundsToPoint
};

export default GoogleMaps;



// WEBPACK FOOTER //
// ./src/lib/google-maps.js